module.exports = __webpack_public_path__ + "static/media/simplificado.c7d5959b.svg";